// extracted by mini-css-extract-plugin
export default {"deviceButton":"ToggleChatButton_deviceButton__99zu5","icon":"ToggleChatButton_icon__Jsdyl","chatIconBadge":"ToggleChatButton_chatIconBadge__zpn0k"};